document.addEventListener('DOMContentLoaded', function() {
  const mainCartIcon = document.querySelector('#cart-icon-bubble');
  
  const additionalCartIcons = [
    document.querySelector('#cart-icon-bubble-search'),
    document.querySelector('#cart-icon-bubble-mobile'),
    document.querySelector('#cart-icon-bubble-scrolled')
  ].filter(icon => icon !== null);

  const cartDrawer = document.querySelector('cart-drawer');
  
  if (mainCartIcon && cartDrawer && additionalCartIcons.length > 0) {
    additionalCartIcons.forEach(cartIcon => {
      cartIcon.setAttribute('role', 'button');
      cartIcon.setAttribute('aria-haspopup', 'dialog');
      
      cartIcon.addEventListener('click', function(event) {
        event.preventDefault();
        if (mainCartIcon) {
          mainCartIcon.click();
        } else {
          cartDrawer.open(cartIcon);
        }
      });
      
      cartIcon.addEventListener('keydown', function(event) {
        if (event.code.toUpperCase() === 'SPACE' || event.code.toUpperCase() === 'ENTER') {
          event.preventDefault();
          if (mainCartIcon) {
            mainCartIcon.click();
          } else {
            cartDrawer.open(cartIcon);
          }
        }
      });
    });

    syncCartCountBubbles();
  }


  function syncCartCountBubbles() {
    console.log('Syncing cart count bubbles');
    const mainCartBubble = document.querySelector('#cart-icon-bubble .cart-count-bubble');
    
    additionalCartIcons.forEach(cartIcon => {
      if (!cartIcon) return;
      
      const cartIconId = cartIcon.id;
      const additionalCartBubble = cartIcon.querySelector(`.cart-count-bubble, .cart-count-bubble-${cartIconId.replace('cart-icon-bubble-', '')}`);
      
      if (!mainCartBubble && additionalCartBubble) {
        additionalCartBubble.remove();
        return;
      }
      
      if (mainCartBubble && !additionalCartBubble) {
        const newBubble = document.createElement('div');
        const cartType = cartIconId.replace('cart-icon-bubble-', '');
        newBubble.classList.add(cartType ? `cart-count-bubble-${cartType}` : 'cart-count-bubble');
        
        const visibleCount = document.createElement('span');
        visibleCount.setAttribute('aria-hidden', 'true');
        visibleCount.textContent = mainCartBubble.querySelector('[aria-hidden="true"]').textContent;
        
        const hiddenCount = document.createElement('span');
        hiddenCount.classList.add('visually-hidden');
        hiddenCount.textContent = mainCartBubble.querySelector('.visually-hidden').textContent;
        
        newBubble.appendChild(visibleCount);
        newBubble.appendChild(hiddenCount);
        
        cartIcon.appendChild(newBubble);
      }
      
      if (mainCartBubble && additionalCartBubble) {
        syncBubbleContents(mainCartBubble, additionalCartBubble);
      }
    });
  }
  
  function syncBubbleContents(sourceBubble, targetBubble) {
    const sourceCount = sourceBubble.querySelector('[aria-hidden="true"]');
    const targetCount = targetBubble.querySelector('[aria-hidden="true"]');
    
    if (sourceCount && targetCount) {
      targetCount.textContent = sourceCount.textContent;
    }

    const sourceHiddenText = sourceBubble.querySelector('.visually-hidden');
    const targetHiddenText = targetBubble.querySelector('.visually-hidden');
    
    if (sourceHiddenText && targetHiddenText) {
      targetHiddenText.textContent = sourceHiddenText.textContent;
    }
  }

  if (mainCartIcon) {
    const observer = new MutationObserver(function(mutations) {
      syncCartCountBubbles();
    });

    observer.observe(mainCartIcon, { 
      childList: true,     
      subtree: true,      
      characterData: true, 
      attributes: true     
    });
  }
  
  // Observer for when the entire cart icon is replaced (common in Shopify themes)
  const bodyObserver = new MutationObserver(function(mutations) {
    for (const mutation of mutations) {
      if (mutation.type === 'childList') {
        const cartIconAdded = Array.from(mutation.addedNodes).some(node => {
          if (node.id === 'cart-icon-bubble') return true;
          if (node.nodeType === 1 && node.querySelector('#cart-icon-bubble')) return true;
          return false;
        });
         
        if (cartIconAdded) {
          console.log('Cart icon added to DOM');
          setTimeout(syncCartCountBubbles, 10);
          const newCartIcon = document.querySelector('#cart-icon-bubble');
          if (newCartIcon) {
            observer.disconnect();
            observer.observe(newCartIcon, { 
              childList: true, 
              subtree: true, 
              characterData: true,
              attributes: true 
            });
          }
        }
      }
    }
  });
  
  bodyObserver.observe(document.body, { 
    childList: true, 
    subtree: true 
  });
  
  syncCartCountBubbles();
  
  const checkInterval = setInterval(function() {
    const mainCartBubble = document.querySelector('#cart-icon-bubble .cart-count-bubble');
    const searchCartBubble = document.querySelector('#cart-icon-bubble-search .cart-count-bubble-search');
    
    if ((mainCartBubble && !searchCartBubble) || (!mainCartBubble && searchCartBubble)) {
      syncCartCountBubbles();
    }
  }, 5000); 
}); 
 